import React, { Component } from 'react'

class SurvivorChip extends Component {
  render() {
    if (this.props.name !== 'DIVIDER') {
      return (
        <span className="mdl-chip mdl-chip--contact mdl-chip--deletable survivorChip">
          <img className="mdl-chip__contact" src={this.props.name ? `/survivor/img/profiles/${this.props.name}.jpg` : `/survivor/img/loading.gif`} alt="Profile"/>
          <span className="mdl-chip__text">{this.props.name ? this.props.name : 'Deciding...'}</span>
        </span>
      )
    }
    else return (
      <h5>Snuffed</h5>
    )
  }
}

export default SurvivorChip
